import * as types from '../mutation-types';

// initial state
const state = {
  updates: [],
};

// getters
const getters = {
  getUpdates: state => state.updates,
};

// mutations
const mutations = {
  [types.SET_PO_UPDATES](state, updates) {
    state.updates = updates;
  },
};

const actions = {
  setUpdates: ({ commit }) => {
    commit(types.USER_LOG_IN);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/updates.js